import React from 'react';
import { Icon } from './Icon.js';
export const IconGridLayoutRows3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M11 10.25C11 11.2165 10.2165 12 9.25 12H2.75C1.7835 12 1 11.2165 1 10.25V9H11V10.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M9.25 0C10.2165 0 11 0.783502 11 1.75V3H1V1.75C1 0.783502 1.7835 0 2.75 0H9.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M11 7.5H1V4.5H11V7.5Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconGridLayoutRows3Fill12.js.map